import howToClaimImg from 'assets/images/howToClaim.svg?url'

import React from 'react'

import { Icon } from 'components/UI'

import { getContrastColor } from 'utils/parsers'

import { Button, Divider, Box, Typography } from '@mui/material'

interface HowToScanBlockProps {
  onAcceptTransfer: () => void
  onWatchVideo: () => void
  isTransferring?: boolean
}

export const HowToScanBlock = ({ onAcceptTransfer, onWatchVideo, isTransferring = false }: HowToScanBlockProps) => {
  const certificateTag = false

  return (
    <Box>
      {certificateTag ? (
        <Typography variant="body2" sx={{ textIndent: '6px' }}>
          1. Hold your phone near your Certificate to scan
        </Typography>
      ) : (
        <Typography variant="body2" sx={{ textIndent: '6px' }}>
          1. Hold your phone near your item to scan, VeraTag located at the back side of the bag
        </Typography>
      )}
      {!certificateTag && (
        <Box my="12px" sx={{ display: 'flex', justifyContent: 'center' }}>
          <img src={howToClaimImg} />
        </Box>
      )}
      <Typography variant="body2" sx={{ textIndent: '6px' }}>
        2. Wait for the scanning process to complete
      </Typography>
      <Divider sx={{ margin: '16px 0' }} />
      <Box mb="44px" sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box mr="12px">
          <Icon name="info" />
        </Box>
        <Typography variant="body2">
          Notice: <br />
          The scanning process is limited by 5 minutes. When time will be expired claiming process will be stopped and
          you should initiate a new one
        </Typography>
      </Box>
      <Button
        sx={theme => ({
          marginBottom: '16px',
        })}
        onClick={onAcceptTransfer}
        fullWidth
      >
        {isTransferring ? 'Transfer certificate' : 'Accept transfer'}
      </Button>
      <Button
        onClick={onWatchVideo}
        variant="outlined"
        fullWidth
        sx={theme => ({ marginBottom: '16px' })}
      >
        Watch video-guide
      </Button>
    </Box>
  )
}
